module.exports = __webpack_public_path__ + "static/media/star-glow.d99aeb13.png";